import { type DietaryRestrictionsText } from './dietary-restrictions-config';

export const getWarningText = (
  dietaryIngredients: DietaryRestrictionsText[]
) => {
  return dietaryIngredients.length > 2
    ? `${dietaryIngredients.slice(0, 2).join(', ')} + ${
        dietaryIngredients.length - 2
      } more`
    : dietaryIngredients?.join(', ');
};
